import { put, select, takeEvery } from 'typed-redux-saga';
import { createNotification, NotificationType } from '@integration-frontends/common/notifications';
import {
  callWithTokenRefresh,
  hubspotGetFolderById,
  hubspotSetFolder,
  selectSelectedClientId,
} from '@integration-frontends/workflow-manager/core/application';
import {
  FORM_INFO_REPO_TOKEN,
  IFormInfoRepo,
} from '@integration-frontends/workflow-manager/core/model';
import { DI_CONTAINER } from '@integration-frontends/core';
import { pageLoadError } from '@integration-frontends/common/app';

function* handler(action: ReturnType<typeof hubspotGetFolderById>) {
  try {
    const { credential_id, sync_folder_id } = action.payload;
    const formInfoRepo: IFormInfoRepo = DI_CONTAINER.get(FORM_INFO_REPO_TOKEN);
    const clientId = yield select(selectSelectedClientId);
    const FOLDERS_PER_PAGE = 20;

    const folders = yield callWithTokenRefresh(formInfoRepo.getHubspotFormInfo, clientId, {
      credential_id,
      folder_id: sync_folder_id,
      per: FOLDERS_PER_PAGE,
      page: 1,
    });

    if (folders) {
      const folder = folders.current_folder;
      yield put(hubspotSetFolder({ sync_folder: folder }));
    } else {
      yield put(
        createNotification({
          message: 'Failed to find HubSpot Folder',
          location: 'topLevel',
          type: NotificationType.Error,
        }),
      );
    }
  } catch (e) {
    yield put(pageLoadError({ error: e }));
  }
}

export function* hubspotGetFolderByIdEffects() {
  yield takeEvery(hubspotGetFolderById, handler);
}
